/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow } from 'bold-ui'
import { useRovingTabIndex } from 'bold-ui/lib/hooks'
import { DropdownButton } from 'components/dropdown'
import React from 'react'

export interface MenuAcoesAgendamentoProps {
  children: React.ReactNode
}

export default function MenuAcoesAgendamento({ children }: MenuAcoesAgendamentoProps) {
  const rootRef = useRovingTabIndex({
    getItems: (root) => Array.from(root.querySelectorAll('button')),
  })

  const withoutDropdown = []
  const withDropdown = []

  React.Children.forEach(children, (child: React.ReactNode) => {
    if (React.isValidElement(child)) child.props.isDropdown ? withDropdown.push(child) : withoutDropdown.push(child)
  })

  return (
    <div ref={rootRef}>
      <HFlow
        hSpacing={0.5}
        alignItems='center'
        style={css`
          height: 100%;
        `}
      >
        {withoutDropdown}
        {withDropdown.length > 0 && <DropdownButton>{withDropdown}</DropdownButton>}
      </HFlow>
    </div>
  )
}
